import { render, staticRenderFns } from "./imageClick.vue?vue&type=template&id=a109869a&"
import script from "./imageClick.vue?vue&type=script&lang=js&"
export * from "./imageClick.vue?vue&type=script&lang=js&"
import style0 from "./imageClick.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports